export const livescoreSliderWrapperTemplate = () =>`
        <div class="view-back hidden-mb endposition">
            <svg class="icon arrow-left"><use xlink:href="#icon-arrow_right"></use></svg>
        </div>
        <div class="view-next hidden-mb">
            <svg class="icon arrow-right"><use xlink:href="#icon-arrow_right"></use></svg>
        </div>
        <div class="carousel-content">        
        </div>
`

